import { Box, Center, Heading, Spinner, VStack, Alert, AlertIcon } from "@chakra-ui/react";

import Form from "./Form";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useProduct from "./hooks/useProduct";
import { CreateProductParams } from "@olagg/db-types";

const Create = () => {
  const [searchParams] = useSearchParams();
  const duplicateId = searchParams.get('duplicate');
  const { createProduct, getProduct, product, isLoading } = useProduct();
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (data: CreateProductParams) => {
    createProduct(data);
  }

  // Si hay duplicateId, cargar el producto original
  useEffect(() => {
    if (duplicateId) {
      getProduct(duplicateId);
    }
  }, [duplicateId])

  // Crear un objeto con los datos del producto pero sin reference_id
  const getProductDataForDuplication = () => {
    if (!product) return null;
    
    return {
      ...product,
      // Limpiar campos que no deben duplicarse
      id: undefined,
      referenceId: undefined,
      slug: `${product.slug}-copia-${Date.now()}`,
      name: `${product.name} (Copia)`,
      displayName: `${product.displayName} (Copia)`,
      codes: [],
      createdAt: undefined,
      updatedAt: undefined,
    };
  };

  const isDuplicating = !!duplicateId;

  if (isDuplicating && error) {
    return (
      <Center w={'full'} pb={4}>
        <VStack color={'white'}>
          <Alert status="error">
            <AlertIcon />
            {error}
          </Alert>
        </VStack>
      </Center>
    );
  }

  return (
    <>
      <Center w={'full'} pb={4}>
        <VStack color={'white'}>
          <Heading my={2}>
            {isDuplicating ? 'Duplicar Producto' : 'Crear Producto'}
          </Heading>
          {isDuplicating && product && (
            <Box color="gray.400" fontSize="sm" mb={4}>
              Creando una copia de: <strong>{product.name}</strong>
            </Box>
          )}
          {
            (isDuplicating && isLoading) ? (
              <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
                <Spinner />
                <Box mt={4} color="white">Cargando datos del producto...</Box>
              </Box>
            ) : (
              <Form 
                product={isDuplicating ? getProductDataForDuplication() : null} 
                onSubmit={onSubmit} 
                isDuplicating={isDuplicating}
              />
            )
          }
        </VStack>
      </Center>
    </>
  )
}

export default Create;